<template>
  <div class="lottery-component">
    <!-- 抽奖模态框 -->
    <div class="lottery-modal" v-show="isVisible" @click.self="minimize">
      <div class="lottery-container">
        <!-- 抽奖主面板 -->
        <div class="lottery-header">
          <h3>{{ $i18n('luckyLottery', '幸运抽奖') }}</h3>
          <span class="close-btn" @click="minimize">×</span>
        </div>

        <div class="lottery-tip">
          <p><strong>{{ $i18n('deductCoins', '中奖扣') }}{{costCoins}}{{ $i18n('goldCoin', '金币') }}</strong>（{{ $i18n('deductAllYouHave', '有多少扣多少') }}）</p>
          <p class="small-tip">{{ $i18n('noDeductIfNotWin', '不中不扣 · 每人仅一次中奖机会') }}</p>

          <div class="my-rate">
            <span>{{ $i18n('myWinRate', '我的中奖率：') }}</span>
            <strong>{{ myBaseRate }}</strong>
            <button
                class="boost-btn"
                @click="showGiftPanel"
            >
              <span class="boost-icon">↑</span> {{ $i18n('boostProbability', '提升概率') }}
            </button>
          </div>
        </div>

        <div class="participants-list">
          <div class="list-title">{{ $i18n('currentParticipants', '当前参与人数') }}：{{ participants.length }}{{ $i18n('people', '人') }}</div>
          <div
              v-for="(user, index) in participants"
              :key="index"
              class="participant-item"
              :class="{ 'is-me': user.id === currentUserId }"
          >
            <div class="user-avatar">
              <img :src="user.avatar || defaultAvatar" alt="用户头像">
            </div>
            <div class="user-info">
              <div class="user-name">
                {{user.nickname}}
                <span v-if="user.id === currentUserId" class="you-badge">({{ $i18n('me', '我') }})</span>
              </div>
              <div class="win-rate">{{ $i18n('winRate', '中奖率') }}: {{user.ratio}}</div>
            </div>
          </div>
        </div>

        <div class="lottery-footer">
          <button class="exit-btn" @click="exitLottery">{{ $i18n('exitLottery', '退出抽奖') }}</button>
        </div>
      </div>

      <!-- 礼物选择面板 -->
      <transition name="slide-up">
        <div class="gift-panel" v-show="showGifts">
          <div class="gift-header">
            <span class="title">{{ $i18n('buyPropBoostWinRate', '购买道具提升中奖率') }}</span>
            <span class="close-gift" @click="hideGiftPanel">×</span>
          </div>
          <div class="gift-list">
            <div
                v-for="(gift,index) in gifts"
                :key="index"
                class="gift-item"
            >
              <div class="gift-icon">
                <img :src="gift.icon" :alt="gift.name">
              </div>
              <div class="gift-info">
                <div class="gift-name">{{gift.name}}</div>
                <div class="gift-desc">
                  <span class="gift-boost">+{{gift.goodLuckyVal}}幸运值</span>
                  <span class="gift-price">售价 ¥{{gift.price}}</span>
                </div>
              </div>
              <button class="buy-btn" @click.stop="selectGift(gift)">购买</button>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 最小化按钮 -->
    <div class="lottery-mini-btn" v-show="isMinimized" @click="restore">
      <span>{{ $i18n('waitForLottery', '等待抽奖') }} {{myBaseRate}}</span>
    </div>
  </div>
</template>

<script>
import {_code, defaultAvatar} from "@/utils/constant";
import {mapGetters} from "vuex";
import wx from "weixin-js-sdk";
import i18nMixin from "@libs/i18nMixin";
export default {
  name: 'LotteryParticipants',
  props: {
    visible: Boolean,
    costCoins: {
      type: Number,
      default: 0
    },
    drawId:{
      type: String
    },
    currentUserId: {
      type: [String, Number],
      required: true
    }
  },
  mixins: [i18nMixin],
  watch:{
    drawId:{
      handler(newVal){
        // debugger
        if(newVal){
          this.loadUserList(newVal);
        }
      },
      deep:true
    }
  },
  data() {
    return {
      participants:[],
      hasBoosted: false,
      myBaseRate: 0,
      defaultAvatar: defaultAvatar,
      showGifts: false,
      isMinimized: false, // 新增：是否最小化到按钮
      gifts: [
        // {
        //   name: '幸运加倍',
        //   icon: require('@/assets/images/lottery/double_lucky.png'),
        //   price: 0.01,
        //   goodLuckyVal:2000
        // },
        {
          name: '四方来财',
          icon: require('@/assets/images/lottery/four_fouth.png'),
          price: 16,
          goodLuckyVal:418
        },
        {
          name: '五福临门',
          icon: require('@/assets/images/lottery/five_lucky.png'),
          price: 26,
          goodLuckyVal:588
        },
        {
          name: '八方来财',
          icon: require('@/assets/images/lottery/eight_lucky.png'),
          price: 36,
          goodLuckyVal:888
        }
      ]
    };
  },
  mounted() {
    // 1. 定义处理函数，绑定 this
    this.handleSocketMessage = this.handleSocketMessage.bind(this);
    this.$store.commit('ADD_MESSAGE_LISTENER', this.handleSocketMessage);
  },
  beforeDestroy() {
    this.$store.commit('REMOVE_MESSAGE_LISTENER', this.handleSocketMessage);
  },
  computed: {
    ...mapGetters(["live","userInfo"]),
    isVisible() {
      return this.visible && !this.isMinimized;
    }
  },
  methods: {
    handleSocketMessage(msg){
      switch (msg.msgType) {
        case _code.JOIN_LOTTERY:{
          // 加入抽奖
          const jsonData = JSON.parse(msg.data);
          console.log('加入抽奖',jsonData.drawId);
          this.loadUserList(jsonData.drawId);
          break;
        }
        case _code.QUIT_LOTTERY:{
          // 退出抽奖
          const jsonData = JSON.parse(msg.data);
          console.log('退出抽奖',jsonData.id);
          this.loadUserList(jsonData.id);
          break;
        }
      }
    },
    loadUserList(drawId){
      this.$http.get(`/api/lottery/getJoinUserList?drawId=${drawId}`).then(res=>{
        this.participants = res.data;
        this.showLottery = true;
        this.showJoin = false;
      })
    },
    // 关闭/最小化组件
    minimize() {
      this.isMinimized = true;
      this.$emit('minimize');
    },

    // 恢复组件显示
    restore() {
      this.isMinimized = false;
    },

    // 完全退出抽奖
    exitLottery() {
      this.isMinimized = false;
      this.$emit('update:visible', false);
      this.$emit('exit',this.drawId);
    },
    showGiftPanel() {
      this.showGifts = true;
    },
    hideGiftPanel() {
      this.showGifts = false;
    },
    selectGift(gift) {
      gift.liveId = this.live.id;
      gift.drawId = this.drawId;
      this.$http.post('/api/dlrLotteryGiftOrder/insert',gift).then(res=>{
        this.hasBoosted = true;
        this.hideGiftPanel();
        wx.miniProgram.navigateTo({
          url: `/pages/wxpay/wxpay?uni=${res.data}&payType=pay_draw_gift`,
        });
      })
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.lottery-component {
  position: relative;
}

.lottery-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  transition: all 0.3s ease;
}

.lottery-container {
  width: 100%;
  max-width: 320px;
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

/* 头部样式 */
.lottery-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lottery-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.close-btn {
  font-size: 24px;
  color: #666;
  cursor: pointer;
  line-height: 1;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #FF6B00;
}

/* 提示信息样式 */
.lottery-tip {
  padding: 12px 20px;
  background-color: #f8f8f8;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.small-tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.lottery-tip strong {
  color: #FF6B00;
  font-weight: bold;
}

.my-rate {
  margin-top: 12px;
  padding: 10px;
  background-color: white;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
}

.my-rate strong {
  font-size: 16px;
}

/* 参与者列表样式 */
.participants-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px;
}

.list-title {
  font-size: 13px;
  color: #999;
  padding: 12px 0 8px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 8px;
}

.participant-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.participant-item:last-child {
  border-bottom: none;
}

.participant-item.is-me {
  background-color: #FFF5ED;
  border-radius: 6px;
  margin: 4px -4px;
  padding: 10px 4px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
  flex-shrink: 0;
  background-color: #f0f0f0;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 14px;
  color: #333;
  margin-bottom: 2px;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.you-badge {
  font-size: 12px;
  color: #FF6B00;
  margin-left: 4px;
  background-color: rgba(255, 107, 0, 0.1);
  padding: 1px 6px;
  border-radius: 4px;
}

.win-rate {
  font-size: 12px;
  color: #666;
}

/* 提升按钮样式 */
.boost-btn {
  padding: 6px 12px;
  background-color: white;
  border: 1px solid #FF6B00;
  border-radius: 15px;
  font-size: 13px;
  color: #FF6B00;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s;
}

.boost-btn:hover {
  background-color: rgba(255, 107, 0, 0.1);
}

.boost-btn:active {
  transform: scale(0.98);
}

.boost-icon {
  display: inline-block;
  margin-right: 4px;
  font-weight: bold;
  transition: transform 0.3s;
}

.boost-btn:hover .boost-icon {
  transform: translateY(-2px);
}

/* 底部按钮样式 */
.lottery-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}

.exit-btn {
  width: 100%;
  padding: 10px;
  background-color: white;
  color: #ff4757;
  border: 1px solid #ff4757;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.exit-btn:hover {
  background-color: rgba(255, 71, 87, 0.1);
}

/* 礼物面板样式 */
.gift-panel {
  position: fixed;
  bottom: 65px;
  left: 0;
  right: 0;
  background-color: white;
  border-radius: 12px 12px 0 0;
  padding: 12px 0 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  max-height: 50vh;
  display: flex;
  flex-direction: column;
}

.gift-header {
  padding: 0 16px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.gift-header .title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.close-gift {
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 4px;
}

.gift-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px;
  /*margin-bottom: 100px;*/
  /*border: 1px solid #FF6B95;*/
}

.gift-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.gift-item:last-child {
  border-bottom: none;
}

.gift-icon {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  flex-shrink: 0;
  background-color: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gift-icon img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.gift-info {
  flex: 1;
  min-width: 0;
  font-size: 13px;
}

.gift-name {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.gift-desc {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.gift-boost {
  color: #FF6B00;
  margin-right: 8px;
}

.gift-price {
  color: #999;
}

.buy-btn {
  padding: 6px 12px;
  background-color: #FF6B00;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.buy-btn:hover {
  background-color: #e05b00;
}

/* 动画效果 */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}

/* 最小化按钮样式 */
.lottery-mini-btn {
  position: fixed;
  top: 10px;
  left: 10px;
  background-color: #FF6B00;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  z-index: 1001;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.lottery-mini-btn:hover {
  background-color: #e05b00;
  transform: translateY(-2px);
}

.lottery-mini-btn:active {
  transform: translateY(0);
}
</style>
